import type { ForecastVersion } from '../../api/cashReport'
import { selectConclusion } from './selectConclusion.ts'

type Props = {
  version: ForecastVersion
  onFix: (code: string) => void
}

function chipClass(confidence?: string) {
  const c = String(confidence || 'low').toLowerCase()
  if (c === 'high') return 'high'
  if (c === 'medium') return 'medium'
  return 'low'
}

function chipLabel(confidence?: string) {
  const c = String(confidence || 'low')
  return `${c.charAt(0).toUpperCase()}${c.slice(1)} confidence`
}

function statePill(kind: string) {
  if (kind === 'below_zero') return { cls: 'below', label: '↓ Below zero' }
  if (kind === 'tight') return { cls: 'tight', label: '⚠ Tight' }
  return { cls: 'covered', label: '✓ Covered' }
}

export default function ConclusionBlock({ version, onFix }: Props) {
  const conclusion = selectConclusion(version)
  const confidence = version.confidence || 'low'
  const reason = version.confidence_reasons?.[0]
  const showFix = confidence !== 'high' && reason
  const pill = statePill(conclusion.kind)
  return (
    <>
      <header className="cr-report-head" data-testid="cr-answer-band">
        <div>
          <div className="eyebrow cr-eyebrow">Company outlook · next 8 weeks</div>
          <h2 data-testid="cr-conclusion">{conclusion.sentence}</h2>
        </div>
        <div className="cr-head-pills">
          <span className={`cr-chip ${pill.cls}`} data-testid="cr-state-pill">{pill.label}</span>
          <span className={`cr-chip muted ${chipClass(confidence)}`} data-testid="cr-confidence">
            {chipLabel(confidence)}
          </span>
        </div>
      </header>
      {showFix ? (
        <div className="cr-reason" data-testid="cr-confidence-reason">
          {reason.label}{' '}
          <button
            type="button"
            className="cr-btn"
            data-testid="cr-fix-action"
            onClick={() => onFix(reason.code)}
          >
            {reason.fix_action || 'Fix'}
          </button>
        </div>
      ) : null}
    </>
  )
}
